import Vue from 'vue'
import App from './App.vue'
import store from './store';

import VueIziToast from 'vue-izitoast'
import VueTour from 'vue-tour'
import 'izitoast/dist/css/iziToast.min.css'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/dayjs'
import '@/filters.js'
import './assets/css/vuetour.css'
import VueApexCharts from 'vue-apexcharts';

Vue.config.productionTip = false
require('vue-tour/dist/vue-tour.css')

Vue.use(VueIziToast)
Vue.use(VueTour)
Vue.use(VueApexCharts)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
